import { supabase } from "@/integrations/supabase/client";

export interface Testimonial {
  id: string;
  name: string;
  handle: string;
  avatar_url: string;
  text: string;
  href?: string;
  is_active: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
}

export async function fetchActiveTestimonials(): Promise<Testimonial[]> {
  const { data, error } = await supabase
    .from("testimonials")
    .select("*")
    .eq("is_active", true)
    .order("display_order", { ascending: true });

  if (error) {
    console.error("Error fetching testimonials:", error);
    throw error;
  }

  return data || [];
}

export async function fetchAllTestimonials(): Promise<Testimonial[]> {
  const { data, error } = await supabase
    .from("testimonials")
    .select("*")
    .order("display_order", { ascending: true });

  if (error) {
    console.error("Error fetching all testimonials:", error);
    throw error;
  }

  return data || [];
}

export async function createTestimonial(testimonial: Omit<Testimonial, "id" | "created_at" | "updated_at">): Promise<Testimonial> {
  const { data, error } = await supabase
    .from("testimonials")
    .insert(testimonial)
    .select()
    .single();

  if (error) {
    console.error("Error creating testimonial:", error);
    throw error;
  }

  return data;
}

export async function updateTestimonial(id: string, updates: Partial<Testimonial>): Promise<Testimonial> {
  const { data, error } = await supabase
    .from("testimonials")
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq("id", id)
    .select()
    .single();

  if (error) {
    console.error("Error updating testimonial:", error);
    throw error;
  }

  return data;
}

export async function deleteTestimonial(id: string): Promise<void> {
  const { error } = await supabase
    .from("testimonials")
    .delete()
    .eq("id", id);

  if (error) {
    console.error("Error deleting testimonial:", error);
    throw error;
  }
} 